{
	"dependencies": {
		"@mairistem/assistant": "^0.3.3",
		"@mairistem/composants": "0.8.0",
		"@mairistem/comptabilite": "^0.4.115",
		"@mairistem/finances-utils": "^0.5.62",
		"@mairistem/liste": "0.11.2",
		"@mairistem/module": "^0.10.8",
		"@mairistem/tools": "0.4.9",
		"@sentry/react": "^10.53.1",
		"@vitejs/plugin-react": "^6.0.1",
		"dayjs": "^1.11.13",
		"decimal.js": "^10.6.0",
		"lodash": "^4.17.21",
		"react": "^18.2.0",
		"react-dom": "^18.2.0",
		"react-router": "^5.2.1",
		"react-router-dom": "^5.3.0",
		"react-toastify": "^11.1.0",
		"recharts": "^3.7.0",
		"rsuite-table": "^5.19.1",
		"vite": "^8.0.9"
	},
	"description": "Gestion des APCP",
	"devDependencies": {
		"@biomejs/biome": "^2.4.9",
		"@testing-library/jest-dom": "^6.9.1",
		"@testing-library/react": "~16",
		"@types/bun": "^1.3.12",
		"@types/lodash": "^4.14.183",
		"@types/react": "~19",
		"@types/react-dom": "~19",
		"@types/react-router": "^5.1.18",
		"@types/react-router-dom": "^5.3.3",
		"@vitest/coverage-v8": "^4.0.18",
		"esbuild": "^0.28.0",
		"happy-dom": "^20.9.0",
		"typescript": "~6",
		"vitest": "^4.1.0"
	},
	"license": "Proprietary",
	"name": "app-apcp",
	"scripts": {
		"build": "NODE_OPTIONS='--max-old-space-size=8096' vite build",
		"build:app": "NODE_OPTIONS='--max-old-space-size=8096' vite build --mode app",
		"lint": "biome check .",
		"lint:fix": "biome check --write .",
		"start": "NODE_ENV=development vite dev",
		"test": "vitest",
		"test:unit": "vitest run"
	},
	"type": "module",
	"version": "0.1.2-beta.71"
}
